import React, { useEffect } from "react";
import { SlideSimulation } from "../../components/simulation/slideSimulation";
import { TextSimulation } from "../../components/simulation/textSimulation";

import WorkProcess from "../../components/simulation/workProcess";
import TimelineSection from "../../components/simulation/timelineSection";
import StepOneForm from "../../components/simulation/simulationTab";
import { useLocation } from "react-router-dom";

export const SimulationPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#form-section") {
      const el = document.getElementById("form-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div>
      <SlideSimulation />
      <TextSimulation />
      <WorkProcess />
      <TimelineSection />
      <div id="form-section">
        <StepOneForm />
      </div>
    </div>
  );
};
